class UserActions {
    constructor() {
        Object.seal(this);
    }

    watched = {};
}

export default UserActions;
